import { Role } from '../../types'
export const canViewAgentCommissions = (role: Role) => [Role.agente, Role.admin, Role.procesos].includes(role)
export const canManageAgentCommissions = (role: Role) => [Role.admin, Role.procesos].includes(role)
